// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__36pjn","errorLogs":"EditorFooter_errorLogs__2L41p"};